<template>
  <div class="login">
    <div class="dl">
      <a href="/"><img src="@/assets/images/logo_paijie.png"></a>
    </div>
    <div class="dl_bj">
      <div class="dl_main">
        <ul>
          <li class="dl_left">
            <a href="/"><img src="@/assets/images/cskj.png" width="420" height="240"></a>
          </li>
          <li class="dl_right">
            <div class="right-login">
              <div class="dl_right_tit">{{$t("login.welcome")}}</div>
              <div class="tips" v-if="errorShow">*{{ error }}</div>
              <div class="dlbd" v-show="!is_setpw">
                <div class="res-item1">
                  <input type="text" :placeholder='$t("login.phone")' maxlength="11" class="input-item1" v-model="loginDatas.phone">
                  <i class="res-icon1 ">
                    <img src="@/assets/images/1.png" width="21" height="21">
                  </i>
                </div>
                <div class="res-item0" v-show="is_pw">
                  <input type="password" placeholder='密码' class="input-item0" v-model="loginDatas.pw">
                  <i class="res-icon1 ">
                    <img src="@/assets/images/3.png" width="21" height="21">
                  </i>
                </div>
                <div class="res-item1" v-show="!is_pw">
                  <input type="text" :placeholder='$t("login.code")' maxlength="6" class="input-item1" v-model="loginDatas.codes">
                  <i class="res-icon1 ">
                    <img src="@/assets/images/3.png" width="21" height="21">
                  </i>
                  <input type="button" class="send_btn" :class="{ sendding : disabled }" @click="sendCode" :disabled="disabled" :value="codeBtn">
                </div>

                <!--  20220427添加 -->
                <div style=" text-align: left;margin-top:15px;color: rgb(104, 104, 104);">
                  <span @click="addEvent" ref="Check" class="el-icon-full-screen"> &nbsp;&nbsp;请阅读并同意</span>&nbsp;

                  《<span @click="Platform"><a ref="span_check_1" style="text-decoration: underline; color: rgb(104, 104, 104);">拍界平台协议</a></span>》与
                  《<span @click="Privacy"><a ref="span_check" style="text-decoration: underline;line-height:40px; color: rgb(104, 104, 104);">拍界隐私协议</a></span>》
                </div>
                <!--  20220427添加	 -->
                <div class="dl-btn1">
                  <button id="dl-btn" class="dl-btn dl-btn-block" @click="loginForm">登录拍界平台</button>
                </div>

                <!-- 20250620 验证码资质未审核通过 先注释 -->
                <div class="tab-login" @click="tab_pw">{{is_pw?'用手机验证码登录/注册 >>':'用手机号和密码登录 >>'}}</div>

              </div>
              <div class="dlbd" v-show="is_setpw">
                <div class="res-item1">
                  <input type="text" disabled maxlength="11" class="input-item1" v-model="loginDatas.phone">
                  <i class="res-icon1 ">
                    <img src="@/assets/images/1.png" width="21" height="21">
                  </i>
                </div>
                <div class="res-item0">
                  <input type="password" placeholder='密码' class="input-item0" v-model="loginDatas.pw">
                  <i class="res-icon1 ">
                    <img src="@/assets/images/3.png" width="21" height="21">
                  </i>
                </div>
                <div class="dl-btn1">
                  <button id="dl-btn" class="dl-btn dl-btn-block" @click="loginForm">设置登录密码</button>
                </div>
              </div>
            </div>
            <div class="right-ma">
              <img src="@/assets/images/ma.jpg">
              <div>扫码关注拍界平台</div>
            </div>
            <!-- <div class="meiyouzhanghao">还没有账号？<a href="#">立即注册</a></div> -->
            <div class="meiyouzhanghao">
              还没有账号？<a href="javascript:;" @click="goRegister">立即注册</a>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <el-dialog :visible.sync="dialogFormVisible1" :before-close="handleClose">
      <div class="agreement">
        <div class="title"><span style="margin-left:20px;">拍界隐私协议</span></div>
        <p>您的隐私对拍界而言至关重要。因此，我们就我们如何收集、使用、披露、转让和存储您的信息制订了隐私政策。请您仔细阅读我们的隐私政策，如有任何问题，请告知我们。 </p>
        <p class="mb">个人信息的收集和使用:
          个人信息是可用于唯一地识别或联系某人的数据。
          您与拍界或某一拍界相关联的公司联系时，可能会被要求提供您的个人信息。拍界及其关联公司可互相分享此等个人信息，并按本隐私政策使用该等信息。拍界及其关联公司还可将此等信息与其他信息合并在一起，用于提供和改进我们的产品、服务、内容和广告宣传。</p>
        <p class="mb">我们收集何种个人信息:
          当您创建一个拍界帐号、登记您送拍的商品时候，我们会收集各种信息，包括您的姓名、电话号码、联系方式及偏好。
          实名认证时或其它情况下，会用到您的身份证号以及持证拍照或是企业执照号与照片等敏感信息，此类信息主要用于认证使用，以保证拍卖的安全与规范，同时我司承诺不会对敏感信息用于其他用途或提供给第三方。
          当您使用拍界与家人和朋友分享您的内容、发送优惠券和产品或者在拍界社区上邀请其他人时，拍界会收集您提供的与上述人士有关的信息，如姓名、电话号码。
        </p>
        <p class="mb">我们如何使用您的个人信息:
          我们收集的个人信息使我们可以将拍界的最新信息及活动预告及时通知您。这些信息还有助于我们改进我们的服务、内容和广告宣传。如果您不希望被列入我们的发送名单中，您可在任何时候通过更新您的偏好选择退出。
          我们还使用个人信息以帮助我们开发、交付和改进我们的产品、服务、内容和广告宣传。
          我们会不时地使用您的个人信息以发送重要通知，如关于报名参拍以及我们的条款、条件和政策变更的通讯。由于此等信息对您与拍界之间的互动至关重要，您不能选择不接收此类通讯。
          我们还会将个人信息用于审计、数据分析和研究等内部目的，以改进拍界的产品、服务和与客户之间的沟通。
          如果您参与抽奖、竞赛或类似推广活动，我们会将您提供的信息用于管理此类活动。</p>
        <p class="mb">收集和使用非个人信息:
          我们也会收集非个人信息——即不会与任何特定个人直接相关联的数据。我们可出于任何目的而收集、使用、转让和披露非个人信息。下文为我们可能收集的非个人信息以及我们如何使用该等信息的一些示例。
          我们会收集诸如行业、区号、位置等信息，以便我们能更好地了解客户的行为，改进我们的产品、服务和广告宣传。
          我们还会收集与客户在我们APP上的活动有关的信息以及从我们其他产品和服务获得的信息。我们会将此类信息汇总用于帮助我们向我们的客户提供更有用的信息，并了解客户对我们APP、产品和服务中的哪些部分最感兴趣。就本隐私政策而言，汇总数据被视为非个人信息。
          如果我们将非个人信息与个人信息合并在一起，则在两类信息合并在一起的期间内，合并后的信息将被视为个人信息。</p>
        <p class="mb">敏感信息的获取和使用:
          我们会在用户知情并同意的情况下获取用户的敏感信息，下面举例说明。
          我们会在实名认证时，由用户提交身份证号、身份证照片、手持身份证照片、企业执照号、执照照片、法人照片等等实名认证所需的必要信息。以确保拍卖的安全与规范。
          此类敏感信息我们承诺不会用于其他用途，也不会提供给第三方。
          当用户注销账号后，敏感信息也将一同注销。</p>
        <p class="mb">许可和app进入:
          拍界对您对本APP的访问和个人使用授予有限的许可，未经我们明确书面同意，您不得修改本APP或其任何部分。这一许可不包括以下内容：任何对本APP或其内容的转售或商业利用；任何对商品与标的目录、说明或价 格的收集和使用；任何对本APP或其内容的衍生利用；任何为其他商业利益而下载或拷贝帐户信息或使用任何数据采集、Robots或类似的数据收集和摘录工具。未经我们的书面许可，严禁对本APP的内容进行系统获取以直接或间接创建或编辑文集、汇编、数据库或人名地址录 （无论是否通过Robots、Spiders、自动仪器或手工操作）。另外，严禁为任何未经本服务条款明确允许的目的而使用本APP上的内容和材料。未经我们明确书面同意，不得以任何商业目的对本APP或其任何部分进行转载、复制、拷贝、出售、转售、访问或以其他方式加以利用。 未经我们明确书面同意，您不得用frame或运用frame技术附上本APP的商标、标识或其他专有信息（包括图像、文字、网页设计或形式）。未经我们明确书面同意，您不得以任何原标记或任何其他"隐藏文本"方式使用我们的名字或商标。任何未经授权的使用都会终止本APP所授予您的权限或许可。</p>
        <p class="mb">您的帐户:
          拍界的网站、在线服务、互动应用程序、电子邮件消息和广告宣传可能会使用“cookies”和其他技术，如像素标签和网站信标。此等技术帮助我们更好地了解用户的行为，告诉我们人们浏览了我们网站的哪些部分，提高和衡量广告以及网络搜索的效果。我们将通过cookies和其他技术收集的信息视为非个人信息。同样，就本隐私政策而言，在非个人信息与个人信息合并在一起的情况下，我们将合并后的信息视为个人信息。
          当您使用我们的网站、在线服务和应用程序时，拍界及我们的合作伙伴也会使用cookies 和其他技术来记住个人信息。在此等情形中，我们的目标是使您在拍界的体验更为方便和个性化。例如：如果我们知道您的姓名，便可以在您下一次访问拍界时向您致以欢迎。如果我们知道您所在的区域，将有助于我们为您提供商品的预计送达时间。如果我们知晓您购买了某种商品或使用某种服务，将有助于我们向您提供个性化的商品推荐，向您发送更符合您兴趣的广告和电子邮件通讯，以及为您提供量身打造的、对您更有用的购物体验。
          如果您希望关闭cookies，且您正在使用IE浏览器，请点击IE的工具选项，然后点击Interent选项，在“隐私”标签卡选中“高级”，将第一方Cookies与第三方Cookies都设成“阻止”或“提示”关闭cookies。如果您使用的是其他浏览器，请与您的供应商联系，以了解如何关闭cookies。但请注意，如果关闭Cookies，将无法使用拍界平台中的某些功能。
          如同大多数APP，我们会自动收集某些信息并存储在日志文件中。这类信息包括IP地址、浏览器类型和语言、互联网服务提供商（ISP）、指示页面和退出页面、操作系统、日期/时间标记和点击流数据。
          我们使用此等信息以了解和分析趋势、管理网站、了解网站上的用户行为以及收集我们用户群整体的人口统计信息。拍界可将此类信息用于我们的营销和广告服务。
          在我们的某些电子邮件中，我们使用连接到拍界APP上内容的“点进URL”（“click-through URL”）。当客户点击其中的一个点进URL时，在到达我们APP上的目标页面之前，将通过一个单独的网络服务器。我们跟踪此等点进数据将有助于我们确定客户对某一主题的兴趣，以及衡量我们与客户之间沟通的效果。如果您不喜欢此等方式的跟踪，请勿点击电子邮件中的文本或图片链接。
          像素标签使我们可以用客户可阅读的格式发送电子邮件，并告知我们邮件是否被打开。我们可将此等信息用于减少向客户发送电子邮件或者不向客户发送电子邮件。</p>
        <p class="mb">账号注销:
          因业务可能涉及金额较大，所以APP内不提供直接注销功能，但在APP内有注销操作提示。注销流程:需在符合通安服务协议约定条件及国家相关法律法规规定的情况下，您可以通过本声明末尾“隐私问题”章节所列的联系渠道，向我们提出注销申请。在您的帐号注销之后，我们将停止为您提供全部或部分服务，并依据您的要求，删除您的个人信息或做匿名化处理，但法律法规另有规定的除外。</p>
        <p class="mb">向第三方披露:
          拍界只会为提供或改进我们的产品、服务和广告宣传之目的而与第三方共享个人信息；而不会为第三方的营销目的与第三方共享个人信息。</p>
        <p>个推(消息推送):
          本APP中包含第三方信息推送服务插件-个推，此插件仅用于获取设备识别码与信息推送服务，已达到标的拍卖信息的实时通知，此外不用其他用途的用户信息收集。</p>
        <p>其他:
          根据您居住国境内外的法律、法律程序、诉讼和/或公共机构和政府部门的要求，拍界可能有必要披露您的个人信息。如果我们认为就国家安全、执法或具有公众重要性的其他事宜而言，披露是必须的或适当的，则我们可披露与您的有关信息。
          如果我们确定为了执行我们的条款和条件或保护我们的经营或用户，披露是合理必须的，则我们可披露与您有关的信息。此外，如果发生重组、合并或出售，则我们可将我们收集的一切个人信息转让给相关第三方。</p>
        <p>个人信息的保护:
          拍界采取各种预防措施，包括行政、技术和实际的措施，以保障您的个人信息免遭丢失、盗用和误用，以及被擅自取阅、披露、更改或销毁。
          当您使用某些拍界产品、服务或应用程序或者在社交网络服务上发帖时，您分享的个人信息会被其他用户看见，并会被他们阅读、收集或使用。对于您决定在上述情形中提交的个人信息，您应自行负责。例如，如果您在论坛发贴公布您的姓名和电子邮件地址，这些信息便是公开的。在使用此类功能时请多加小心。</p>
        <p>个人信息的完整性和保留:
          拍界将使您能够方便地确保您的个人信息是准确、完整和最新的。我们将在实现本隐私政策中所述目的所必需的期间内保留您的个人信息，除非法律要求或允许在更长的期间内保留该等信息。</p>
        <p>访问个人信息:
          通过登录您的账户，您能够帮助我们确保您的联系方式和偏好是准确、完整和最新的。对于其他个人信息，我们将作出诚信的努力使您有权访问该等信息，以便您能够要求我们对不准确的数据加以纠正，对依据法律或出于合法的商业目的拍界无需保留的数据予以删除。我们有权拒绝处理不合理的重复性要求，需要在技术上作出不相称的努力的要求，损害他人隐私权的要求，极不现实的要求以及根据当地法律无需给予信息访问权的要求。</p>
        <p>第三方网站和服务:
          拍界的APP、产品、应用程序和服务中可能含有第三方网站、产品和服务的链接。我们的产品和服务也可能使用或提供来自第三方的产品或服务。第三方收集的、其中可能含有位置数据或联系方式等的信息，受第三方隐私惯例的管辖。我们提请您了解该等第三方的隐私惯例。</p>
        <p>全公司对您隐私的承诺:
          为确保您个人信息的安全，我们将公司的隐私和安全准则告知全体拍界雇员，并将在公司内部严格执行隐私保护措施。</p>
        <p class="mb">隐私问题:
          如果您对拍界的隐私政策或数据处理有任何问题或顾虑，请按照下文所列的电话号码400-9005-905联系我们。
          拍界可随时对其隐私政策加以更新。如果我们对隐私政策作出重大变更，我们将在公司APP上刊登通告和经更新的隐私政策。</p>
        <br><br>
        <p style="text-align:right;">拍界拍卖有限公司</p>
        <p style="text-align:right;">热线:400-9005-905</p>

      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handelClick1" style="width: 200px;font-size:16px;">已阅读</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="dialogFormVisible" :before-close="handleClose">
      <div class="agreement">
        <div class="title"><span style="margin-left:20px;">拍界平台注册协议</span></div>
        <p>为了规范拍卖人实施网络拍卖的行为，根据《中华人民共和国拍卖法》和《拍卖管理办法》等国家相关法律、法规的规定及拍界拍卖有限公司（以下简称“拍界平台”）有关规则。拍卖人在平台发布的标的信息、上传的图文信息必须遵守法律法规的规定，本着公开、公平、公正、自愿、诚实信用的原则，参加拍卖的意向竞买人（甲方）和拍界平台（乙方）共同遵守以下协议：</p>
        <p class="mb">1.拍界平台实行注册会员制度。依照适用法律能够合法签署具有法律约束力合同的企业或个人可以注册成为拍界平台的会员。未满十八周岁或不具有完全民事行为能力的个人，不具备主体资格或被列入失信名单的企业不可注册为本网站的正式会员。申请注册必须提供有效的个人（或法人）身份证件、营业执照、常住地址、手机号码及其他联系电话和电子邮件地址等材料。注册的用户名应符合法律规定、不违背社会公序良俗，否则乙方有权拒绝其注册及竞买。</p>
        <p class="mb">2.用户一经注册或使用拍界平台服务即视为对本协议所有条款的理解和接受。拍界平台有权在必要时单方修改或变更本协议的内容，并将通过拍界平台网站（地址：https://paijie.com）公布最新的协议，不另作个别通知。若甲方于任何修改或变更本协议条款后继续使用拍界平台服务，则视为甲方已阅读、了解并同意接受修改或变更，若甲方不同意，则甲方应主动立即停用拍界平台服务。</p>
        <p class="mb">3.甲方使用拍界平台的服务须通过乙方的实名认证，并对需认证信息的真实性、合法性、有效性、完整性等承担法律责任。甲方提供的实名认证信息有任何错误、虚假、失效、过期或不完整的情况，乙方有权立即停止甲方的使用权限，并视情况保留追究甲方法律责任的权利。</p>
        <p class="mb">4.甲方应妥善保管自己的账户、密码等信息，防止泄漏。甲方由于自己的原因而致使账户、密码失密造成的损失由甲方自行全部承担。</p>
        <p class="mb">5.甲方须保证提供给乙方的所有信息均真实有效，手机等通讯联系方式畅通，在接受乙方告知等信息后及时反馈，因甲方原因造成信息无法传达的责任自负。</p>
        <p class="mb">6.甲方保证不利用技术或其他手段攻击乙方网络、破坏乙方系统，否则甲方承担由此给乙方或任何第三方造成的损失。</p>
        <p class="mb">7.乙方对相关电子数据进行保留并作为对甲方提供服务行为的证明。</p>
        <p class="mb">8.乙方对甲方的账户资料、委托事项和拍界平台服务密码负有保密义务，未经甲方许可，乙方不得透露甲方在乙方的任何信息资料。但乙方按照有关法律、法规和规章的规定或有关司法机关、行政管理机关的要求提供甲方的有关资料不在此限。 </p>
        <p class="mb">9.暂停、中止或终止拍界平台服务</p>
        <p>（一）甲方同意，如乙方基于自身独立判断或第三方举报或投诉，认为甲方已经违反任何国家法律、法规的规定或本协议任何条款，乙方有权暂停、中止或终止向甲方提供在拍界平台上的服务。</p>
        <p>（二）甲方同意，发生下列情形之一的，乙方无需进行事先通知即可暂停、中止或终止向甲方提供拍界平台服务, 并不承担由此带来的任何损失。</p>
        <p>（1）甲方提供的个人资料不真实，且未能提供合理说明及证明；</p>
        <p>（2）甲方违反相关法律、法规、规章及政府规范性文件或本协议约定；</p>
        <p>（3）电脑黑客攻击；</p>
        <p>（4）乙方根据标的委托方的合理要求；</p>
        <p>（5）乙方认为存在安全隐患。</p>
        <p class="mb">10.拍界平台账户及其密码和安全性甲方了解并同意,甲方可通过拍界平台账户使用拍界平台服务，并确保上述账户及其密码的安全。甲方将对利用上述账户及其密码所进行的一切行为负完全责任，并同意以下事项：</p>
        <p>（一）甲方不对其他任何人泄露甲方的拍界平台账户、密码和安全证书等身份信息，亦不得使用其他任何人的拍界平台账户、密码和安全证书等身份信息。所有通过甲方的拍界平台账户和密码进行的任何操作、发出的任何指令均视为甲方本人做出。</p>
        <p>（二）甲方同意如发现有第三人冒用或盗用甲方的拍界平台账户、密码和安全证书或其他任何未经甲方合法授权使用的情形，应立即以有效方式通知拍界平台，拍界平台在接受甲方的有效通知前，对第三人使用拍界平台服务已发生的效力，将不承担任何责任。</p>
        <p>（三）当甲方的拍界平台账户使用完毕后，甲方应安全退出。如因甲方未按照本协议的约定使用拍界平台账户、保管不善等原因导致的盗号、密码失窃、个人信息泄露等，由甲方自行承担相关的损失。</p>
        <p>（四）因甲方泄露拍界平台账户交易密码、验证码等身份认证信息或介质保管不善、未尽到防范风险与保密义务或因甲方引起的其他原因（包括但不限于点击钓鱼链接，泄露交易密码或信息，甲方使用的计算机被他人侵入等情况）导致的损失由甲方自行承担。</p>
        <p class="mb">11.乙方拥有向用户提供网络服务过程中所产生并储存于服务器中的所有数据信息的所有权，拥有拍界平台内容的著作权、网站域名权利以及商业秘密、技术秘密等知识产权，任何人不得非法使用以上信息和权利，否则须承担相应的法律责任。</p>
        <p class="mb">12.甲方清楚地了解使用拍界平台可能遭受的风险，并自愿承担由该种风险而导致的损失。甲方注册之前，已经详细阅读了本协议包括乙方免责条款在内的所有条款，并已准确理解其含义。</p>
        <p class="mb">13.在本协议履行过程中，因下列情形导致甲方损失的，乙方不承担责任：</p>
        <p>a.因地震、火灾、台风及其他不可抗力引起停电、网络系统故障、电脑故障；</p>
        <p>b.因电信部门的通讯线路故障、通讯技术缺陷、电脑黑客或计算机病毒等问题造成委托系统不能正常运转；</p>
        <p>c.法律和政策重大变化或乙方不可预测和不可控制因素导致的突发事件；</p>
        <p>d.因通讯、网络中断、堵塞等情况致使系统无法正常使用；</p>
        <p>e.因设备或通讯故障致使双方信息未能及时交换的；</p>
        <p>f.因甲方对设备的错误操作和对有关信息的错误理解导致甲方损失的；</p>
        <p>g.因甲方的故意或疏忽导致拍界平台服务密码泄露或遗失，由此导致甲方损失的；</p>
        <p>h.法律规定和本协议约定的其他乙方免责事项。</p>
        <p class="mb">14.发生下述情况时协议终止，至终止情形发生时终止。</p>
        <p>1. 双方书面同意终止；</p>
        <p>2. 一方违约，另一方书面通知对方终止本协议；</p>
        <p>3. 因不可抗力使本协议无法继续履行。</p>
        <p class="mb">15.乙方不向甲方提供竞拍场地、竞拍设备、网络支持等竞拍服务。竞拍前，请甲方提前测试自有设备和网络的正常通畅使用，并在开拍前，在乙方平台提供的测试功能中熟悉拍卖流程。由于甲方设备、网络问题或操作失误所带来的损失，均有甲方自行承担。</p>
        <p class="mb">16.乙方平台组织的每场拍卖会均有《拍卖须知协议》和《重要声明》等内容。甲方自缴纳保证金后即表示同意并遵守以上内容要求（甲乙双方不再书面签署）。如甲方违反以上的约定内容，产生的一切后果均由甲方自行承担。</p>
        <p class="mb">17.甲、乙双方如有争议，应尽可能通过协商、调解解决，协商、调解不成，向乙方实际经营地的法院起诉。</p>
        <p class="mb">18.本协议自甲方在拍界平台网站（地址：https://paijie.com）上注册完成之日起生效。</p>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handelClick" style="width: 200px;font-size:16px;">已阅读</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<style>
.el-icon-check {
  color: red;
}
.el-icon-full-screen {
  color: rgb(104, 104, 104);
}
</style>
<script>

import qs from 'qs'
export default {
  metaInfo: {
    title: "拍界——唤醒您的沉睡资产",
    meta: [{
      name: "keywords",
      content: "拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
    }, {
      name: "description",
      content: "拍界是一个专注拍卖的网络平台，拍卖无边界，拍卖更便捷。拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
    }]
  },
  name: 'Login',
  data () {
    return {
      loginDatas: {
        phone: '',
        codes: '',
        pw: ''
      },
      codeBtn: this.$t("login.send_code"),
      disabled: false,
      errorShow: false,
      error: '',
      only_once: true,
      dialogFormVisible: false,
      dialogFormVisible1: false,
      is_pw: true,
      is_setpw: false,
      token: '',

    }
  },
  watch: {

  },
  created () {
    // 隐藏公共栏
    this.$emit('header', false);
    this.$emit('footer', false);
    this.$emit('shortcutOperation', false);
  },
  mounted () {

  },
  methods: {
    goRegister () {
      this.$router.push('/register');
    },
    // 20220427添加
    addEvent (e) {
      // console.log(e.currentTarget.className);
      let check = "el-icon-full-screen";
      let no_check = "el-icon-check";

      if (e.target.className == no_check) {
        // 修改文字
        e.target.innerText = " 请阅读并同意";
        this.$refs.span_check_1.style.color = " rgb(104, 104, 104)";
        this.$refs.span_check.style.color = " rgb(104, 104, 104)";
        e.currentTarget.parentElement.style.color = " rgb(104, 104, 104)";
        event.currentTarget.className = "el-icon-full-screen"

      } else {
        // 修改文字

        e.target.innerText = " 已阅读并同意";
        this.$refs.span_check_1.style.color = "#FF0000";
        this.$refs.span_check.style.color = "#FF0000";
        e.currentTarget.parentElement.style.color = "#FF0000";
        event.currentTarget.className = "el-icon-check"
      }



    },
    Platform (e) {
      this.dialogFormVisible = true;
    },
    Privacy (e) {
      this.dialogFormVisible1 = true;
    },
    // 20220427添加
    tab_pw () {
      this.is_pw = !this.is_pw;
    },
    handleClose () {
      this.$router.go(-1);
    },
    handelClick () {
      this.dialogFormVisible = false;
    },
    handelClick1 () {
      this.dialogFormVisible1 = false;
    },
    // 发送验证码
    sendCode () {
      const pattern = /0?(13|14|15|17|18|19)[0-9]{9}/;
      if (this.loginDatas.phone == '' || !pattern.test(this.loginDatas.phone)) {
        this.error = this.$t("login.phone_error")
        this.errorShow = true
        this.only_once = true
      } else {
        if (this.only_once == true) {
          this.only_once = false;
          let phoneData = qs.stringify({ 'phone': this.loginDatas.phone })
          this.axios.post(this.$global.apiUrl.send_code, phoneData, {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          })
            .then((response) => {
              if (response.data.error.code == 0) {
                let times = 0
                let i = setInterval(() => {
                  times++
                  if (times >= 60) {
                    this.disabled = false,
                      this.codeBtn = this.$t("login.reacquire")
                    this.only_once = true;
                    clearInterval(i)
                  } else {
                    let balance = 60 - times
                    this.codeBtn = balance + "s",
                      this.disabled = true
                    this.only_once = false;
                  }
                }, 1000)
                this.errorShow = false
              } else {
                this.error = response.data.error.message
                this.errorShow = true
                this.only_once = true
              }
            })
            .catch(() => { })
        }
      }
    },
    loginForm () {
      // this.errorShow = false;

      let Check = this.$refs.Check.className;




      if (this.is_setpw) {
        let phoneDatas = qs.stringify({
          'apiToken': this.token,
          'pw': this.loginDatas.pw
        })
        this.axios.post(this.$global.apiUrl.setpw, phoneDatas, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })
          .then((response) => {

            if (response.data.error.code == 0) {
              this.$router.go(-1)
              this.$emit('header', true)
              this.$emit('footer', true)
            } else {
              this.$alert(response.data.error.message, '提示', {
                confirmButtonText: '确定'
              });
            }


          })


      } else if (Check == 'el-icon-full-screen') {
        // 20220427添加
        this.$alert('请勾选相关协议！', '提示', {
          confirmButtonText: '确定'
        });

        // 20220427添加
      } else if (this.is_pw) {

        let phoneDatas = qs.stringify({
          'phone': this.loginDatas.phone,
          'pw': this.loginDatas.pw
        })

        this.axios.post(this.$global.apiUrl.loginpw, phoneDatas, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })
          .then((response) => {

            if (response.data.error.code == 0) {
              this.errorShow = false
              localStorage.setItem("apiToken", response.data.apiToken);

              this.$router.go(-1)
              this.$emit('header', true)
              this.$emit('footer', true)
            } else {

              this.$alert(response.data.error.message, '提示', {
                confirmButtonText: '确定'
              });
            }

          })
      } else {
        let phoneDatas = qs.stringify({
          'phone': this.loginDatas.phone,
          'code': this.loginDatas.codes
        })
        this.axios.post(this.$global.apiUrl.login, phoneDatas, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })
          .then((response) => {

            if (response.data.error.code == 0) {
              this.errorShow = false
              localStorage.setItem("apiToken", response.data.apiToken);


              if (response.data.setPass) {
                this.token = response.data.apiToken;
                this.$alert('请设置登录密码', '提示', {
                  confirmButtonText: '确定'
                });
                this.is_setpw = true;
              } else {
                this.$router.go(-1)
                this.$emit('header', true)
                this.$emit('footer', true)
              }


              // localStorage登录信息存储
              // Storage.prototype.setExpire = (key, value, expire) => {
              // 	let obj = {
              // 		data: value,
              // 		time: Date.now(),
              // 		expire: expire
              // 	};
              // 	//localStorage 设置的值不能为对象,转为json字符串
              // 	localStorage.setItem(key, JSON.stringify(obj));
              // }
              // Storage.prototype.getExpire = key => {
              // 	let val = localStorage.getItem(key);
              // 	if (!val) {
              // 		return val;
              // 	}
              // 	val = JSON.parse(val);
              // 	if (Date.now() - val.time > val.expire) {
              // 		localStorage.removeItem(key);
              // 		return null;
              // 	}
              // 	return val.data;
              // }
              // // 一周后自動清除localStorege
              // localStorage.setExpire('apiToken', response.data.apiToken, 604800);
              // window.setInterval(()=>{
              // 	localStorage.getExpire("apiToken");
              // }, 1000)
            } else {
              this.$alert(response.data.error.message, '提示', {
                confirmButtonText: '确定'
              });
            }
            // 20220427添加
            if (Check == 'el-icon-full-screen') {

              this.$alert('请勾选相关协议！', '提示', {
                confirmButtonText: '确定'
              });
            }
            // 20220427添加	

          })
      }

    }
  },
  computed: {

  }
}



</script>
